/** @format */

import React, { PureComponent, ReactNode } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../../assets/jss/adescom/adescomStyle';
import Select from '@material-ui/core/Select';
import { FormControl, Input, InputAdornment, ListItemText, MenuItem } from '@material-ui/core';
import { Magnify } from 'mdi-material-ui';
import I18n from '../../../../components/Translate/I18n';
import HeaderCheckBoxElement from './HeaderCheckBoxElement';
import { connect } from 'react-redux';
import { FilterReducerFieldName, FilterReducers } from '../../../../modules/filter/FilterReducers';
import { ExtraHeaderValuesInterface } from '../../../../components/Table/TableHeaderContentCell';
import SearchNull from '../../../../components/Adescom/SearchNull';
import GridContainer from '../../../../components/Grid/GridContainer';
import Grid from '@material-ui/core/Grid';
import OPL_STYLE from '../../../../assets/themes/OPL/OplStyle';
import i18n from '../../../../core/i18n';
import { ReactComponent as ArrowDown } from '../../../../assets/themes/OPL/img/icons/ArrowDown.svg';

export interface HeaderListProps {
    fieldName: string;

    handleChange(fieldName: string, value: Array<number> | Array<string> | Array<boolean> | string, items?: any): void;

    elementList?: Array<object>;
    extraValues?: Array<ExtraHeaderValuesInterface>;
    nullable?: boolean;
}

interface Classes {
    formControl: string;
    selected: object;
    selectIcon: string;
    tableHeaderMenuItem: string;
}

interface HeaderCheckBoxSelectListProps {
    dispatch: any;
    classes: Classes;

    handleChange(values: Array<number> | string): void;

    elements: Array<HeaderCheckBoxSelectListElement>;
    fieldName: string;
    clearField?: boolean;
    nullable?: boolean;
}

interface HeaderCheckBoxSelectListState {
    selected: Array<number>;
    backGroundColor: string;
    hasValue: boolean;
    nulled?: boolean;
}

export interface HeaderCheckBoxSelectListElement {
    name: string;
    value: number;
    platformResellerName?: string | null;
    hiddenName?: string | null;
}

export interface HeaderCheckBoxSelectListElementValueString {
    name: string;
    value: string;
    platformResellerName?: string | null;
}

class HeaderCheckBoxSelectList extends PureComponent<HeaderCheckBoxSelectListProps, HeaderCheckBoxSelectListState> {
    constructor(props: HeaderCheckBoxSelectListProps, context: HeaderCheckBoxSelectListState) {
        super(props, context);
        this.state = {
            selected: [],
            backGroundColor: OPL_STYLE.BACKGROUND.SECONDARY,
            hasValue: false,
            nulled: false,
        };
    }

    componentDidUpdate(prevProps: Readonly<HeaderCheckBoxSelectListProps>, prevState: Readonly<HeaderCheckBoxSelectListState>, snapshot?: any): void {
        const { clearField, dispatch } = this.props;
        const { hasValue } = this.state;
        if (hasValue && clearField) {
            this.clearInput();
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            });
        }
    }

    clearInput = (): void => {
        this.setState({
            selected: [],
            backGroundColor: OPL_STYLE.BACKGROUND.SECONDARY,
            hasValue: false,
        });
    };

    handleChange = (checked: boolean, value: number | string): void => {
        const { selected } = this.state;
        const { handleChange, dispatch, fieldName } = this.props;

        if (value === '') {
            this.setState({ selected: [], hasValue: false, nulled: false }, () => {
                handleChange([]);
                dispatch({
                    type: 'headerFilterManage',
                    headerFilterElementName: fieldName,
                    headerFilterElementHasValue: false,
                });
            });
            return;
        }
        if (value === 'null') {
            this.setState({ hasValue: true, nulled: true }, () => {
                handleChange('null');
                dispatch({
                    type: 'headerFilterManage',
                    headerFilterElementName: fieldName,
                    headerFilterElementHasValue: true,
                });
            });
            return;
        }

        // if (typeof value === 'string') {
        //     return;
        // }

        const selectedCopy = selected;
        if (checked) {
            // @ts-expect-error: this can be string so we'll need to fix this later
            selectedCopy.push(value);
        } else {
            // @ts-expect-error: this can be string so we'll need to fix this later
            selectedCopy.splice(selectedCopy.indexOf(value), 1);
        }
        let color = OPL_STYLE.FONT_COLOR.PRIMARY;
        if (selectedCopy.length > 0) {
            color = OPL_STYLE.FONT.COLOR;
        }
        this.setState({ selected: selectedCopy, backGroundColor: color, hasValue: selectedCopy.length > 0 }, () => {
            handleChange(selectedCopy);
        });
        dispatch({
            type: 'headerFilterManage',
            headerFilterElementName: fieldName,
            headerFilterElementHasValue: selectedCopy.length > 0,
        });
    };

    render(): ReactNode {
        const { classes, elements, nullable, fieldName } = this.props;
        const { selected, backGroundColor, nulled } = this.state;
        return (
            <GridContainer style={{ marginRight: nullable ? '40px' : '0' }}>
                {nullable && (
                    <Grid item xs={3}>
                        <SearchNull fieldType={'checkbox'} fieldName={fieldName} value={nulled ? 'null' : ''} updateCallback={this.handleChange} />
                    </Grid>
                )}
                <Grid item xs={nullable ? 9 : 12} style={{ paddingLeft: nullable ? '10px' : '0px' }}>
                    <FormControl className={classes.formControl} style={{ minWidth: '100px', maxWidth: 100, fontSize: '0.6rem' }}>
                        <Select
                            IconComponent={ArrowDown}
                            classes={{
                                icon: classes.selectIcon,
                            }}
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        boxShadow: '0px 6px 32px -6px rgba(66, 68, 90, 1)',
                                    },
                                },
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left',
                                },
                                style: {
                                    marginLeft: -28,
                                },
                                elevation: 0,
                                getContentAnchorEl: null,
                            }}
                            multiple={true}
                            native={false}
                            value={selected}
                            disabled={!!nulled}
                            renderValue={(): string => {
                                const arr: Array<string> = [];
                                this.props.elements.map((el) => {
                                    this.state.selected.map((el2) => {
                                        if (el2 === el.value) {
                                            arr.push(i18n.t(el.name));
                                        }
                                    });
                                });

                                return arr.join(',');
                            }}
                            input={
                                <Input
                                    id="select-multiple-checkbox"
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <Magnify fontSize={'small'} />
                                        </InputAdornment>
                                    }
                                />
                            }
                        >
                            {selected &&
                                elements.map((value) => (
                                    <MenuItem key={value.value} value={value.value} dense={true} className={classes.tableHeaderMenuItem}>
                                        <HeaderCheckBoxElement selected={selected} value={value} handleChange={this.handleChange} />
                                        <ListItemText
                                            primary={<I18n trans={value.name} valueObject={{ platformResellerName: value.platformResellerName }} />}
                                        />
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>
            </GridContainer>
        );
    }
}

const stateToProps = (state: { filterReducer: FilterReducers }): object => {
    const { filterReducer } = state;
    if (filterReducer && filterReducer.clearAll) {
        return {
            clearField: true,
        };
    }
    return {};
};

export default compose<any, any>(connect(stateToProps), withStyles(adescomStyle))(HeaderCheckBoxSelectList);
